import { render, staticRenderFns } from "./cardCollapse.vue?vue&type=template&id=603af448&scoped=true"
import script from "./cardCollapse.vue?vue&type=script&lang=js"
export * from "./cardCollapse.vue?vue&type=script&lang=js"
import style0 from "./cardCollapse.vue?vue&type=style&index=0&id=603af448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603af448",
  null
  
)

export default component.exports